<template>
    <button
        class="border border-black p-2 uppercase w-full text-2xl px-4 whitespace-nowrap"
        :class="[
            tourClass,
            isActive ? 'bg-black text-white' : 'bg-white text-black',
        ]"
        @click="$emit('click', $event)"
    >
        <slot/>
    </button>
</template>

<script>
    export default {
        props: {
            tourClass: String,
            isActive: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
